<div class="overlay" *ngIf="isDownloading">
     <h1 class="heading" [innerHtml]="'Loading' | translator:'base'">Loading...</h1>
     <img [alt]="'Loading' | translator:'base'" />
</div>
<div class="overlay" *ngIf="isPaying">
     <h1 class="heading" [innerHtml]="'Processing' | translator:'base'">Processing...</h1>
     <img [alt]="'Processing' | translator:'base'" />
</div>
<div class="overlay" *ngIf="isLoading">
     <h1 class="heading" [innerHtml]="'Loading' | translator:'base'">Loading...</h1>
     <img [alt]="'Loading' | translator:'base'" />
</div>
<ng-template #ConfirmPayModal let-modal id="confirmPayModal" name="confirmPayModal">
     <div class="modal-header">
          <h3 id="confirmPayModalTitle" name="confirmPayModalTitle" class="modal-title"
               [innerHtml]="'confirmPayment' | translator:'invoice'">
               Confirm Payment
          </h3>
     </div>
     <div class="modal-body" id="confirmDefaultPaymentMethodModalText">
          <div class="m-0">
               <table class="table table-collapsible mb-15">
                    <thead>
                         <tr>
                              <th scope="col" [innerHtml]="'InvoiceNumber' | translator:'invoice'"
                                   name="invoiceNumberHeaderConfirm" id="invoiceNumberHeaderConfirm">
                                   Invoice #
                              </th>
                              <th scope="col" class="right" [innerHtml]="'AmountDue' | translator:'invoice'"
                                   name="amountDueHeader" id="amountDueHeader">
                                   Amount Due
                              </th>
                              <th scope="col" class="right" [innerHtml]="'AmountToPay' | translator:'invoice'"
                                   name="amountToPayAmount" id="amountToPayAmount">
                                   Amount Paying
                              </th>
                         </tr>
                    </thead>
                    <tbody>
                         <tr *ngFor="let i of displayPaymentDetails">
                              <td class="text-break">
                                   <span class="cell-label" [innerHtml]="'InvoiceNumber' | translator:'invoice'">
                                        Invoice Number
                                   </span>
                                   <span class="float-right-onExpanded" *ngIf="i.invoiceId > 1">{{ i.invoiceId }}</span>
                                   <span class="float-right-onExpanded" *ngIf="i.invoiceId === 0"
                                        [innerHtml]="'notProcessed' | translator:'invoice'">Not Processed</span>
                              </td>
                              <td class="text-break right">
                                   <span class="cell-label float-left" [innerHtml]="'AmountDue' | translator:'invoice'">
                                        Amount Due
                                   </span>
                                   <span class="float-right-onExpanded">
                                        {{ formatMoney(i.startingBalance) }}
                                   </span>
                              </td>
                              <td class="text-break right">
                                   <span class="cell-label float-left"
                                        [innerHtml]="'AmountToPay' | translator:'invoice'">
                                        Amount Paying
                                   </span>
                                   <span class="float-right-onExpanded">
                                        {{ formatMoney(i.amountToPay) }}
                                   </span>
                              </td>

                         </tr>
                    </tbody>
                    <tfoot>
                         <tr>
                              <th class="right bold">
                                   <span class="float-left" [innerHtml]="'totalText' | translator:'invoice'">
                                        Total:
                                   </span>
                              </th>
                              <th class="right">
                                   <span class="float-right-onExpanded">{{ formatMoney(totalDueForBill) }}</span>
                              </th>
                              <th class="right bold">
                                   <span class="float-right-onExpanded">{{ formatMoney(totalAmountPaying) }}</span>
                              </th>
                         </tr>
                    </tfoot>
               </table>
          </div>
          <div *ngIf="paymentIsCard()">
               <div *ngIf="cardSurcharge > 0" class="mb-3">
                    <span class="help-block text-danger" [innerHtml]="'payingByCard' | translator:'invoice'">
                         Credit card payments incur a surcharge of
                    </span>
                    <span class="help-block text-danger"> {{ cardSurcharge }}%.</span>
               </div>
          </div>
     </div>
     <div class="modal-footer" id="defaultModalFooter">
          <button class="btn btn-primary" [title]="'payNow' | translator:'invoice'" (click)="newPayment()"
               [innerHtml]="'payNow' | translator:'invoice'">
               Pay Now
          </button>
          <button class="btn btn-default" [title]="'Cancel' | translator:'base'" (click)="cancelPayment()"
               [innerHtml]="'Cancel' | translator:'base'">
               Cancel
          </button>
     </div>
</ng-template>
<ng-template #paymentSuccessModal let-modal id="showPaymentSuccess" name="showPaymentSuccess" variant="success"
     (dismissed)="closeSuccess()">
     <div class="modal-header">
          <h3 class="modal-title" [innerHtml]="'Success' | translator:'customer'" id="successModalTitle"
               name="successModalTitle">SUCCESS</h3>
     </div>
     <div class="modal-body" id="confirmDefaultPaymentMethodModalText">
          <div class="m-0">
               <div>
                    <p class="modal-title" >
                         <span [innerHtml]="'payment_success_a' | translator:'invoice'">
                              Thank you for your payment! A receipt of this payment has been sent to 
                         </span>{{ this.userProfile?.userData!.email }}<span *ngIf="showPrimaryEmail()"><span [innerHtml]="paymentSuccess('and')"> and </span>{{ this.userProfile?.primaryContactEmail! }}</span>.
                    </p>
                    <br />
                    <p>
                         <span [innerHtml]="'payment_success_id' | translator:'invoice'">Payment ID:</span> {{ paymentId
                         }}
                    </p>
               </div>
               <div [innerHtml]="'payment_success_contact' | translator:'invoice'">
                    Please contact the PSP customer service team with any questions regarding your invoice or account.
               </div>
          </div>
     </div>
     <div class="modal-footer" id="defaultModalFooter">
          <button class="btn btn-primary" [title]="'Close' | translator:'base'" (click)="cancelPayment()"
               [innerHtml]="'Close' | translator:'base'">
               Close
          </button>
     </div>
</ng-template>
<ng-template #paymentErrorModal let-modal id="showPaymentError" name="showPaymentError" (dismissed)="closeError()"
     variant="danger">
     <div class="modal-header">
          <h3 class="modal-title" id="errorModalTitle" name="errorModalTitle">
               <span [innerHtml]="'payment_error' | translator:'invoice'">There was a problem with your payment. Please
                    contact customer service at </span>
               <a href="tel:1-877-642-9499" title="1-877-642-9499">1-877-642-9499</a>.
          </h3>
     </div>
     <div class="modal-body" id="confirmDefaultPaymentMethodModalText">
          <div class="m-0">
               <div [innerHtml]="'payment_success_contact' | translator:'invoice'">
                    Please contact the PSP customer service team with any questions regarding your invoice or account.
               </div>
          </div>
     </div>
     <div class="modal-footer" id="defaultModalFooter">
          <button class="btn btn-primary" [title]="'Close' | translator:'base'" (click)="closeError()">
               <span [innerHtml]="'Close' | translator:'base'">Close</span>
          </button>
     </div>
</ng-template>
<div class="card shadow-sm rounded-0 border-0 mb-3">
     <div class="card-body">
          <table class="table table-collapsible mb-0">
               <caption [innerHtml]="'invoiceActivityCaption' | translator:'invoice'" class="sr-only">
                    Table results for your invoice activity.
               </caption>
               <thead>
                    <tr>
                         <th scope="col" [innerHtml]="'InvoiceNumber' | translator:'invoice'" name="invoiceNumberHeader"
                              id="invoiceNumberHeader">
                              Invoice Number
                         </th>
                         <th scope="col" [innerHtml]="'BillingPeriod' | translator:'invoice'" name="billingPeriodHeader"
                              id="billingPeriodHeader">
                              Billing Period
                         </th>
                         <th scope="col" [innerHtml]="'Status' | translator:'invoice'" name="statusHeader"
                              id="statusHeader">
                              Status
                         </th>
                         <th scope="col" class="right" [innerHtml]="'AmountBilled' | translator:'invoice'"
                              name="remainingBalanceHeader" id="remainingBalanceHeader">
                              Amount Billed
                         </th>
                         <th scope="col" class="right" [innerHtml]="'RemainingBalance' | translator:'invoice'"
                              name="AmountBalance" id="AmountBalance">
                              Remaining Balance
                         </th>
                         <th scope="col" class="left" [innerHtml]="'invoiceActions' | translator:'invoice'"
                              name="invoiceActionsHeader" id="invoiceActionsHeader">
                              Actions
                         </th>
                    </tr>
               </thead>
               <tbody>
                    <tr *ngFor="let invoice of invoices; let idx = index">
                         <td class="text-break">
                              <span class="cell-label" [innerHtml]="'InvoiceNumber' | translator:'invoice'">Invoice
                                   Number</span>
                              <span class="float-right-onExpanded" *ngIf="invoice.invoiceId !== '0'">
                                   {{ invoice.invoiceId }}
                              </span>
                              <span class="float-right-onExpanded" *ngIf="invoice.invoiceId === '0'"
                                   [innerHtml]="'notProcessed' | translator:'invoice'">
                                   Not Processed
                              </span>
                         </td>
                         <td class="text-break">
                              <span class="cell-label" [innerHtml]="'BillingPeriod' | translator:'invoice'">Billing
                                   Period</span>
                              {{ formatBillCycle(invoice.billCycle) }}
                         </td>
                         <td>
                              <span class="cell-label" [innerHtml]="'Status' | translator:'invoice'">Status</span>
                              <span *ngIf="invoice.paidInFull === 'Unpaid' && !isThisBillCycle(invoice.billCycle)"
                                   [innerHtml]="'Due' | translator:'invoice'">Due</span>
                              <span *ngIf="invoice.paidInFull === 'Paid'"
                                   [innerHtml]="'Paid' | translator:'invoice'">Paid</span>
                              <span *ngIf="isThisBillCycle(invoice.billCycle)"
                                   [innerHtml]="'Open' | translator:'invoice'">Open</span>
                         </td>
                         <td class="right">
                              <span class="cell-label float-left" [innerHtml]="'AmountBilled' | translator:'invoice'">
                                   Amount Billed
                              </span>
                              {{ formatMoney(invoice.totalAmount) }}
                         </td>
                         <td class="right">
                              <span class="cell-label float-left" [innerHtml]="'AmountBalance' | translator:'invoice'">
                                   Remaining Balance
                              </span>
                              {{ formatMoney(parseFloat_(invoice.outstandingAmount)) }}
                         </td>
                         <td class="left act-width" *ngIf="invoice.invoiceId !== '0'">
                              <button class="btn btn-outline-primary btn-sm mb-2 me-2"
                                   [title]="'viewInvoice' | translator:'invoice'"
                                   (click)="download(parseFloat_(invoice.invoiceId), invoice.billCycle)"
                                   [innerHtml]="'viewInvoice' | translator:'invoice'">
                                   View Invoice
                              </button>
                              <button class="btn btn-primary btn-sm me-2 mb-2"
                                   *ngIf="showPayment === true && invoice.outstandingAmount !== '0.00' && !isThisBillCycle(invoice.billCycle)"
                                   href="#scroll-target" [disabled]="invoice.outstandingAmount === '0.00'"
                                   [title]="'payInvoice' | translator:'invoice'" (click)="openPaymentWindow(invoice)"
                                   [innerHtml]="'payInvoice' | translator:'invoice'">
                                   Pay Invoice
                              </button>
                         </td>
                    </tr>
                    <tr 
                         class="psp-no-rows-container"     
                         *ngIf="invoices && invoices?.length === 0"
                    >
                         <td class="text-break" colspan="6">
                              <div>
                                   No Rows To Show
                              </div>
                         </td>                         
                    </tr>
               </tbody>
               <tfoot>
                    <tr>
                         <th colspan="4">
                              <span class="float-end" [innerHtml]="'TotalDue' | translator:'invoice'">
                                   Total Due:
                              </span>
                         </th>
                         <td class="right bold" colspan="2">
                              <span class="cell-label float-left" [innerHtml]="'TotalDue' | translator:'invoice'">
                                   Total Due:
                              </span>
                              <b>{{ formatMoney(totalBalance) }}</b>
                         </td>
                         <td *ngIf="showPayment === true && showPayAll === true" class="left" colspan="1">
                              <button style="margin-left:105px; min-width:94px;"
                                   class="btn btn-primary btn-sm me-2 mb-2" [disabled]="totalBalance === 0"
                                   (click)="openPaymentWindowAll()" [title]="'payAll' | translator:'invoice'"
                                   [innerHtml]="'payAll' | translator:'invoice'">
                                   Pay All
                              </button>
                         </td>
                    </tr>

               </tfoot>
          </table>
     </div>
</div>
<div #creatingPaymentBox id="creatingPaymentBox"></div>
<div *ngIf="!creatingPayment">
     <p>
          <span [innerHtml]="'PaymentDirections1a' | translator:'invoice'">Above you will find all outstanding invoice
               not yet paid. </span>
          <span [innerHtml]="'PaymentDirections1b' | translator:'invoice'" class="bold">There are three ways to pay an
               invoice: </span>
     </p>
     <ul>
          <li [innerHtml]="'PaymentDirections1c' | translator:'invoice'">ACH Debit (US Only)</li>
          <li [innerHtml]="'PaymentDirections1d' | translator:'invoice'">Credit Card</li>
          <li [innerHtml]="'PaymentDirections1e' | translator:'invoice'">Check</li>
     </ul>
     <p [innerHtml]="'PaymentDirections1f' | translator:'invoice'">Click the Manage Payment Methods button to set up an
          automatic payment for the 10th of each month.</p>
     <p [innerHtml]="'PaymentDirections2' | translator:'invoice'" class="bold">Mail checks to:</p>
     <p>NIC Federal (DOT)<br />
          P.O. Box 74008301<br />
          Chicago, IL 60674-8301
     </p>

</div>

<fieldset *ngIf="creatingPayment" class="card shadow-sm rounded-0 border-0 mb-3" aria-labelledby="submitPaymentLabel">
     <div class="card-body">
          <legend class="h5">
               <span id="submitPaymentLabel" [innerHtml]="'oneTimePayment' | translator:'invoice'">Submit Payment</span>
               <a href="#" [title]="'Close' | translator:'base'" class="float-right pointer btn-close"
                    (click)="closeCreatingPayment()" aria-label="Close"></a>
          </legend>
          <div class="row mb-3">
               <label class="form-label">
                    <span [innerHtml]="'invoiceLabel' | translator:'invoice'">Invoice</span>
                    <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
               </label>
               <div class="col-12">
                    {{ selectedInvoicesIds }}
               </div>
          </div>
          <div class="row mb-3">
               <label class="form-label" for="paymentAmount">
                    <span [innerHtml]="'invoicePaymentAmount' | translator:'invoice'">Payment Amount</span>
                    <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
               </label>
               <div class="col-6">
                    <input type="text" [(ngModel)]="paymentAmount" name="paymentAmount" id="paymentAmount"
                         disabled="true" class="bg-light form-control nonRequiredMargin" />
               </div>
               <div class="col-6"></div>
          </div>
          <div class="row mb-3" *ngIf="selectedMethodId > 0">
               <div class="col-6">
                    <label class="form-label" for="paymentMethod">
                         <span [innerHtml]="'invoicePaymentMethod' | translator:'invoice'">Payment Method</span>
                         <span class="text-danger text-center ms-1" [title]="'Required' | translator:'base'">*</span>
                    </label>
                    <select [(ngModel)]="selectedMethodId" id="paymentMethod" name="paymentMethod"
                         [ngModelOptions]="{ standalone: true }" class="bg-light form-select nonRequiredMargin"
                         [title]="'invoicePaymentMethod' | translator:'invoice'">
                         <option *ngFor="let d of displayMethods" [ngValue]="d.methodId"
                              [selected]="d.isDefault ? 'selected' : null">
                              <span *ngIf="d.isCC" [innerHtml]="'creditCard' | translator:'invoice'">Credit Card</span>
                              <span *ngIf="!d.isCC">ACH</span>
                              {{ ' (*' + d.accountNumber +') ' }}
                              <span *ngIf="d.isDefault"
                                   [innerHtml]="'default_account' | translator:'invoice'">(Default)</span>
                         </option>
                    </select>
               </div>
               <div class="col-6"></div>
          </div>
          <div class="row mb-3" *ngIf="paymentIsCard()">
               <div class="col-12">
                    <span class="help-block text-danger" [innerHtml]="'payingByCard' | translator:'invoice'">
                         Credit card payments incur a surcharge of
                    </span>
                    <span class="help-block text-danger"> {{ cardSurcharge }}%.</span>
               </div>
          </div>
          <div class="row">
               <div class="col-12">
                    <button *ngIf="selectedMethodId > 0" class="btn btn-primary mb-2 me-2"
                         [title]="'payNow' | translator:'invoice'" (click)="payNow()" id="btnPayNowMethods_"
                         name="btnPayNowMethods_" [disabled]="paymentAmount === '$0.00'"
                         [innerHtml]="'payNow' | translator:'invoice'">
                         Pay Now
                    </button>
                    <a [routerLink]="['/payment']" class="btn btn-primary mb-2 me-2"
                         [title]="'PaymentMethodsHeader' | translator:'base'" (click)="scrollToTop()"
                         id="btnManagePaymentMethods_" name="btnManagePaymentMethods_"
                         [innerHtml]="'PaymentMethodsHeader' | translator:'base'">
                         Manage Payment Methods
                    </a>
                    <span class="fst-italic" *ngIf="selectedMethodId <= 0"
                         [innerHtml]="'noAccountsAdded' | translator:'invoice'">
                         No electronic payment methods available.
                    </span>
               </div>
          </div>
     </div>
</fieldset>

<div class="row mb-3" *ngIf="!creatingPayment">
     <div class="col-12">
          <a [routerLink]="['/payment']" class="btn btn-primary " [title]="'PaymentMethodsHeader' | translator:'base'"
               (click)="scrollToTop()" id="btnManagePaymentMethods" name="btnManagePaymentMethods"
               [innerHtml]="'PaymentMethodsHeader' | translator:'base'">
               Manage Payment Methods
          </a>
     </div>
</div>